import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25AcademicGridsListComponent } from "./s25.academic.grids.list.component";
import { GridListItem } from "../../services/grids.service";
import { Bind } from "../../decorators/bind.decorator";
import { TelemetryService } from "../../services/telemetry.service";
import { LynxService } from "../../services/lynx.service";
import { S25Const } from "../../util/s25-const";

@TypeManagerDecorator("s25-ng-academic-grids-page")
@Component({
    selector: "s25-ng-academic-grids-page",
    template: `
        <h1>Academic Grids</h1>
        @if (!chosenGrid) {
            <s25-ng-academic-grids-list [selectGrid]="selectGrid"></s25-ng-academic-grids-list>
        } @else {
            <s25-ng-schedule-only-grid
                [grid]="chosenGrid"
                (exit)="onGridExit()"
                [editable]="(expSecEnabled || S25Const.isInternalInstance) && chosenGrid.isOwner && chosenGrid.editable"
            ></s25-ng-schedule-only-grid>
        }
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25AcademicGridsPageComponent implements OnInit {
    @ViewChild(S25AcademicGridsListComponent) listComponent: S25AcademicGridsListComponent;

    chosenGrid: GridListItem;
    expSecEnabled: boolean = false;
    protected readonly S25Const = S25Const;

    constructor(
        private cd: ChangeDetectorRef,
        private elementRef: ElementRef,
    ) {
        elementRef.nativeElement.angBridge = this;
    }

    async ngOnInit() {
        this.expSecEnabled = await LynxService.getExpSecEnabled();
    }

    @Bind
    async selectGrid(grid: GridListItem) {
        if (!grid) return;
        TelemetryService.sendWithSub("MPG", "Academic", "View");
        this.chosenGrid = grid;
        this.cd.detectChanges();
    }

    onGridExit() {
        this.chosenGrid = null; // Unloads the grid component
        this.cd.detectChanges();
    }
}
